import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

export interface CardContainerStyles {
    cardDivider?: InjectableCss;
    gridItem?: GridItemProps;
}

export const cardContainerStyles: CardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0 10px;
            border-bottom: 1px solid ${getColor("common.border")};
            margin-bottom: 40px;
            margin: 0px;
        `,
    },
    gridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            /* padding:0px; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css`
                        padding-left: 25px;
                        padding-right: 25px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
};

const CardContainerWishlist: FC<{
    extendedStyles?: CardContainerStyles;
}> = ({ extendedStyles, children }) => {
    const [styles] = React.useState(() => mergeToNew(cardContainerStyles, extendedStyles));

    return <GridItem {...styles.gridItem}>{children}</GridItem>;
};

export default CardContainerWishlist;
